module.exports = __webpack_public_path__ + "media/images/lp-reward-icon@2x-ed2761858b52ae2bc82f06566632b912.png";